import React from "react";
import {useLocation} from "react-router-dom";
import {locations} from "../../Utilities/Location";
import headerLandingImage from "../../images/HeaderLanding.svg";
import headerImage from "../../images/Header.svg";

export const HeaderBasic: React.FC = () => {
    const location = useLocation();
    const isLandingPage = location.pathname === locations.LANDING.path;
    const src = isLandingPage ? headerLandingImage : headerImage;
    const className = isLandingPage ? "header header--landing" : "header";

    return (
        <header className={className}>
            <img 
                src={src} 
                alt="RMTC-DHH Media and Materials Loan Library" 
                className="header__image"
            />
        </header>
    );
};
